import variables from "variables/variables"

const debugLogTypes = [
   'mixpanel',
   'lock',
   'formhandler',
   'api',
   'websocket',
   'auth',
   'markdown',
   'scribe'
] as const
type DebugLogType = (typeof debugLogTypes)[number]

export default class Debug {
   type: DebugLogType

   constructor(type: DebugLogType) {
      this.type = type
   }

   static get log() {
      return debugLogTypes.reduce((acc, type) => {
         acc[type] = new Debug(type).logIfEnabled
         return acc
      }, {} as Record<DebugLogType, (...args: Parameters<typeof console.log>) => void>)
   }

   static toggle = (): boolean => {
      const enabled = localStorage.getItem('gap-debug') === 'true'
      if (enabled) {
         localStorage.removeItem('gap-debug')
         return false
      } else {
         localStorage.setItem('gap-debug', 'true')
         return true
      }
   }

   private static isEnabled = () => {
      return localStorage.getItem('gap-debug') === 'true' || variables.stage.startsWith('dev')
   }

   private logIfEnabled: typeof console.log = (...args) => {
      const enabled = Debug.isEnabled()
      if (enabled) {
         return console.log(`[${this.type}]`, ...args)
      }
   }
}
